/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FilteredQuery } from '../../models/filtered-query';
import { GetTasksQueryResult } from '../../models/get-tasks-query-result';
import { SortedQuery } from '../../models/sorted-query';
import { TaskStatus } from '../../models/task-status';

export interface ApiTaskGetTasksGet$Plain$Params {
  Status?: TaskStatus;
  IsLate?: boolean;
  MeetingId?: string;
  PageNumber?: number;
  PageSize?: number;
  Filters?: Array<FilteredQuery>;
  Sorts?: Array<SortedQuery>;
  SearchTerm?: string;
}

export function apiTaskGetTasksGet$Plain(http: HttpClient, rootUrl: string, params?: ApiTaskGetTasksGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetTasksQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiTaskGetTasksGet$Plain.PATH, 'get');
  if (params) {
    rb.query('Status', params.Status, {});
    rb.query('IsLate', params.IsLate, {});
    rb.query('MeetingId', params.MeetingId, {});
    rb.query('PageNumber', params.PageNumber, {});
    rb.query('PageSize', params.PageSize, {});
    rb.query('Filters', params.Filters, {});
    rb.query('Sorts', params.Sorts, {});
    rb.query('SearchTerm', params.SearchTerm, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetTasksQueryResult>;
    })
  );
}

apiTaskGetTasksGet$Plain.PATH = '/api/Task/GetTasks';
